var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional, IsString } from 'class-validator';
import { Heilmittelbereich } from '../../pvs-billing/enums/heilmittelbereich.enum.js';
import { IsValidBillingCode } from '../validators/abrechnungscode.js';
import { IsValidIk } from '../validators/institutionskennzeichen.js';
/**
 * Body for `POST /office-locations/:officeLocationId/leistungserbringer`.
 *
 * The `IsValidIk` decorator checks shape, Prüfziffer and the
 * Heilmittel Klassifikation whitelist. The narrower per-Bereich check needs both
 * fields at once and therefore runs in the domain, not here.
 */
export class CreateLeistungserbringerDto {
    heilmittelbereich;
    ik;
    billingCode;
    /**
     * Optional, and **off** when omitted (#1513). Entering an IK says "this is who
     * we are"; it does not say "start sending our Abrechnung electronically".
     */
    participatesInGkvBilling;
}
__decorate([
    Expose(),
    IsEnum(Heilmittelbereich),
    __metadata("design:type", String)
], CreateLeistungserbringerDto.prototype, "heilmittelbereich", void 0);
__decorate([
    Expose(),
    IsString(),
    IsValidIk(),
    __metadata("design:type", String)
], CreateLeistungserbringerDto.prototype, "ik", void 0);
__decorate([
    Expose(),
    IsString(),
    IsValidBillingCode(),
    __metadata("design:type", String)
], CreateLeistungserbringerDto.prototype, "billingCode", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateLeistungserbringerDto.prototype, "participatesInGkvBilling", void 0);
//# sourceMappingURL=create-leistungserbringer.dto.js.map